import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Soportes } from "@/components/Soportes";
import { Beneficios } from "@/components/Beneficios";
import { RedEdificios } from "@/components/RedEdificios";
import { SobreEdimedia } from "@/components/SobreEdimedia";
import { Contacto } from "@/components/Contacto";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <BrowserRouter>
      <div style={{ backgroundColor: "#050505", minHeight: "100vh" }}>
        <Toaster position="top-right" theme="dark" />
        <Navbar />
        <main>
          <Hero />
          <Soportes />
          <Beneficios />
          <RedEdificios />
          <SobreEdimedia />
          <Contacto />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
